import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Plus } from "lucide-react";
import CreateTicketForm from "./Support/CreateTicketForm";
import TicketList from "./Support/TicketList";
import TicketDetail from "./Support/TicketDetail";

const Support = () => {
  const { token } = useSelector((state) => state.auth);
  const [currentView, setCurrentView] = useState('list'); // 'list', 'detail'
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);


  const handleCreateTicket = () => {
    setShowCreateForm(true);
  };

  const handleTicketCreated = (newTicket) => {
    setShowCreateForm(false);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleTicketSelect = (ticketId) => {
    setSelectedTicketId(ticketId);
    setCurrentView('detail');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedTicketId(null);
  };

  const handleTicketUpdated = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  // Render different views
  const renderView = () => {
    switch (currentView) {
      case 'detail':
        return (
          <TicketDetail
            ticketId={selectedTicketId}
            onBack={handleBackToList}
            token={token}
            onTicketUpdated={handleTicketUpdated}
          />
        );
      default:
        return (
          <TicketList
            onTicketSelect={handleTicketSelect}
            token={token}
            refreshTrigger={refreshTrigger}
          />
        );
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Support Center</h2>
        <button
          onClick={handleCreateTicket}
          className="bg-secondary text-white px-4 py-2 rounded-lg font-medium hover:bg-green-700 transition-colors flex items-center gap-2"
        >
                <Plus className="w-4 h-4" />
                New Ticket
              </button>
            </div>

      {renderView()}

      {/* Create Ticket Modal */}
      {showCreateForm && (
        <CreateTicketForm
          onClose={() => setShowCreateForm(false)}
          onTicketCreated={handleTicketCreated}
          token={token}
        />
      )}
    </div>
  );
};

export default Support;
